import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
        >
          <path d="M5.884 5l3.933-3.932a.625.625 0 10-.885-.885L5 4.116 1.068.183a.625.625 0 10-.885.885L4.116 5 .183 8.933a.625.625 0 10.885.884L5 5.884l3.932 3.933a.623.623 0 00.885 0 .625.625 0 000-.885L5.884 5z"></path>
        </svg>
    );
}